import IParser from "@/types/IParser"
import { IUser } from "./user.types"
import { User } from "./user"
import ParseError from "@/types/ParseError"

type IUserRaw = {
  id: number
  email: string
  first_name?: string | null
  locked?: string | null
  created_at: string
  sign_in_count: number
  current_sign_in_ip?: string | null
  customer_user_rels: {
    customer_id?: number
  }[]
}

export const UserParser: IParser<IUser, IUserRaw> = {
  toDomain: (data) => {
    try {
      return new User(
        data.id,
        data.email,
        data.first_name ?? "",
        data.created_at,
        data.sign_in_count,
        data.current_sign_in_ip ?? "",
        data.customer_user_rels[0]?.customer_id,
        data.locked ?? undefined,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
